import axios from 'axios'
import { asyncApi } from '@/services/apiService'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/providers'

export default {
  async getAll(filter) {
    return await axios
      .get(endpoint + `/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getAllActive() {
    return await axios
      .get(endpoint + '/list/active')
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getAllActiveWoSubscriber() {
    return await axios
      .get(endpoint + '/list/activewosubscriber')
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getMasterOperators(onBeginCallback, onFinallyCallback) {
    return asyncApi.get(`${endpoint}/list/master-operator`, onBeginCallback, onFinallyCallback);
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async uploadImage(request) {
    return await axios
      .post(endpoint + '/image', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/provider/providerService.js